import { render, staticRenderFns } from "./assignResellersModule.vue?vue&type=template&id=3d66d1ac&"
import script from "./assignResellersModule.vue?vue&type=script&lang=js&"
export * from "./assignResellersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports